import type { ReactNode } from 'react';

import { Modal } from './Modal/Modal';

import styles from './DetailsModal.module.scss';

interface DetailsModalProps {
  children: ReactNode | (() => ReactNode);
  onCloseModalClick: () => void;
}

export const DetailsModal = ({ children, onCloseModalClick }: DetailsModalProps) => (
  <Modal
    customStyle="bottomSheet"
    centered
    className={styles.container}
    contentClass={styles.modalContent}
    dialogClass={styles.modal}
    dismissModal={onCloseModalClick}
    shouldCloseOnEsc={true}
    shouldCloseOnOverlayClick={true}
    size="small"
    withCloseButton={true}
  >
    <div className={styles.popoverContent}>
      {typeof children === 'function' ? children() : children}
    </div>
  </Modal>
);
